import { Box, Container, Grid, makeStyles, Typography, useTheme, IconButton, Tooltip, Zoom } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import QCXFooter from '../footer/QCXFooter';
import QCXBreadcrumbs from '../breadcrumbs/QCXBreadcrumbs';

import UsFlagImg from '../../assets/images/us.png';
import UkFlagImg from '../../assets/images/uk.png';
import JpFlagImg from '../../assets/images/jp.png';
import { doGetQCXRequest } from '../../utils/api/domain/domain-api-utils';

const useStyles = makeStyles((theme) => ({
  box: {
    width: 'inherit',
  },
  grow: {
    flexGrow: 1,
  },
  card: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4),
    width: '100%',
    marginLeft: '-12px',
  },
  tooltip: {
    marginTop: -8,
  },
}));

const TaxaVigente = ({ symbol, src, taxaHoje, taxaAmanha }) => {
  const classes = useStyles();

  const taxaHojeFormatado = String(taxaHoje)?.replace?.('.', ',');
  const taxaAmanhaFormatado = String(taxaAmanha)?.replace?.('.', ',');

  const textoAmanha = taxaAmanha ? `BRL ${taxaAmanhaFormatado}` : 'Disponível após as 14h';

  return (
    <Tooltip
      title={`Amanhã: ${textoAmanha}`}
      TransitionComponent={Zoom}
      leaveDelay={300}
      classes={{ tooltip: classes.tooltip }}
    >
      <Box display="flex" alignItems="center" style={{ gap: 4 }}>
        {src ? <img alt="Bandeira da moeda" style={{ width: 16, height: 16 }} src={src} /> : null}
        {symbol ? <p style={{ color: 'white', fontSize: 16 }}>{symbol}</p> : null}

        <p style={{ color: 'white' }}>BRL {taxaHojeFormatado}</p>
      </Box>
    </Tooltip>
  );
};

export default function QCXNavigatorContent({
  additionalClasses,
  page,
  children,
  breadcrumbs = [],
  breadcrumbsProps,
  ...restProps
}) {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const [taxasVigentes, setTaxasVigentes] = useState(null);

  const [taxaDolar, taxaLibra, taxaEuro, taxaIene] = useMemo(() => {
    if (!taxasVigentes) return [];

    const getTaxaBySigla = (sigla) => ({
      hoje: taxasVigentes.hoje?.find((t) => t.moeda.sigla === sigla)?.taxaConversao,
      amanha: taxasVigentes.amanha?.find((t) => t.moeda.sigla === sigla)?.taxaConversao,
    });

    return [getTaxaBySigla('USD'), getTaxaBySigla('GBP'), getTaxaBySigla('EUR'), getTaxaBySigla('JPY')];
  }, [taxasVigentes]);

  const fetchTaxasVigentes = useCallback(async () => {
    const response = await doGetQCXRequest(['taxaconversaocambio', 'taxas-vigentes']);

    if (response.status === 200) setTaxasVigentes(response.data);
  }, []);

  useEffect(() => {
    fetchTaxasVigentes();
  }, [fetchTaxasVigentes]);

  return (
    <Grid container direction="row" justify="flex-start" className="fixed-footer">
      <Box display="flex" direction="row" justifyContent="space-between" alignItems="center" className="title-bar">
        <Box alignItems="center">
          {/* {
              history.location.pathname !== '/' && (
                <Grid
                  item
                  xs={3}
                  sm={2}
                  md={1}
                  xl={1}
                >
                  <IconButton onClick={history.goBack}>
                    <ArrowBack />
                  </IconButton>
                </Grid>
              )
            } */}
          <Box>
            {page?.icon}
            <Typography variant="h1" color="textPrimary">
              {page?.title}
            </Typography>
            {/* <Typography fontWeight="fontWeightBold" style={{ color: 'yellow' }}>
                Atenção!!! A plataforma ficará indisponível no dia 01 de Agosto a partir das 19h para que seja realizada
                a atualização da versão.
              </Typography> */}
          </Box>
        </Box>
        <Box className={classes.grow} display="flex" justifyContent="center" style={{ gap: 12 }}>
          {taxasVigentes ? (
            <>
              <TaxaVigente src={UsFlagImg} taxaHoje={taxaDolar?.hoje} taxaAmanha={taxaDolar?.amanha} />
              <TaxaVigente src={UkFlagImg} taxaHoje={taxaLibra?.hoje} taxaAmanha={taxaLibra?.amanha} />
              <TaxaVigente symbol="€" taxaHoje={taxaEuro?.hoje} taxaAmanha={taxaEuro?.amanha} />
              <TaxaVigente src={JpFlagImg} taxaHoje={taxaIene?.hoje} taxaAmanha={taxaIene?.amanha} />
            </>
          ) : null}
        </Box>
        <Box justify="flex-end" alignItems="center" style={{ marginRight: theme.spacing(3) }}>
          <Typography color="secondary" fontWeight="fontWeightBold">
            <a
              href="https://modelos-relatorios.s3.amazonaws.com/integracao/faturas/Itens+liberados+da+Vers%C3%A3o+Quick+Comex+1.pdf"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              {process.env?.REACT_APP_QCX_VERSION}
            </a>
          </Typography>
        </Box>
      </Box>

      <>
        {breadcrumbs?.length > 0 ? (
          <Grid item container direction="row" alignItems="center" justify="space-between" className="breadcrumbs-bar">
            <Grid item container xs={11} alignItems="center" style={{ marginLeft: theme.spacing(1) }}>
              <QCXBreadcrumbs data={breadcrumbs} {...breadcrumbsProps} />
            </Grid>
            {history.location.pathname !== '/' && (
              <IconButton onClick={history.goBack}>
                <ArrowBack color="secondary" />
              </IconButton>
            )}
          </Grid>
        ) : (
          <> </>
        )}
        <Grid item container direction="row" className={classes.card}>
          <Container {...restProps} style={{ display: 'flex', minHeight: 'calc(100vh - 250px)' }}>
            <Box component={Grid} container className={classes.box} justify="center" alignItems="flex-start">
              {children}
            </Box>
          </Container>
        </Grid>
      </>
      <QCXFooter />
    </Grid>
  );
}
